<template lang="pug">
.background-page-sumut.login-sumut
  v-container(grid-list-md)
    v-layout(wrap)
      v-flex.mt-6(lg5, md5, xs12, hidden-xs-only)
        v-card.card-login(elevation="6")
          v-card-text
            v-carousel(height="250px", :show-arrows="false", cycle)
              v-carousel-item(v-for="(item, i) in items", :key="i")
                f-banner-image-content(:value="item")
        v-layout(wrap)
          v-flex.mt-2.text-center.justify-center(lg6, md6, xs12)
            .call-logo
            .lock-logo
            v-btn.caption.font-weight-bold.white--text.text-capitalize(
              text,
              @click="routeToInfoMenu('SECURITY_BANKING')"
            ) Tips Keamanan Perbankan
          v-flex.mt-2(lg6, md6, xs12)
            .ojk-logo
            .sectigo-logo
            .caption.font-weight-bold.white--text.text-center This site chose Sectigo SSL for secure e-commerce and confidential communications
          v-layout.mt-1
          v-flex.justify-center.text-center(lg12, md12, xs12)
            v-btn.caption.font-weight-bold.amber--text.text-capitalize(
              text,
              @click="routeToInfoMenu('SECURITY_PRIVACY')"
            ) Kebijakan Privacy dan Pengamanan
            v-btn.caption.font-weight-bold.amber--text.text-capitalize(
              text,
              @click="routeToInfoMenu('SECURITY_FAQ')"
            ) Frequently Asked Questions
      v-flex.mt-6(lg3, md3, xs12, hidden-sm-only, hidden-xs-only)
        v-card.card-login
          v-card-text
            .subtitle-2.font-weight-bold.primary--text.mt-3 {{ prop.name }}
            v-divider 
            .caption-bold Layanan ini digunakan untuk mempermudah transaksi keuangan untuk instansi / korporasi
            .subtitle-2.font-weight-bold.primary--text.mt-3 Info Penting
            v-divider 
            .caption-bold Jaga kerahasiaan User ID, Password, Alamat Email dan Token Anda.
              .caption-bold.black--text.mt-2 Jangan beritahu kepada pihak lain termasuk staf Bank Sumut.
            .caption-bold.mt-2 Jika terjadi HAL YANG TIDAK WAJAR / BIASA, Hentikan Transaksi dan segera konfirmasi ke BankSUMUT Call : 14002
            .subtitle-2.font-weight-bold.primary--text.mt-3 Kontak Kami
            v-divider 
            .subtitle-2.font-weight-bold.mt-2 Bank Sumut Call : 14002
            v-layout.mt-1(wrap)
              v-icon(size="18px", color="indigo") mdi-web
              a.caption-bold.black--text(
                :href="prop.websiteInfo.linkWebsite",
                target="_blank",
                style="color: #757474; text-decoration: none; margin-left: 5px"
              ) {{ prop.websiteInfo.website }}
            v-layout.mt-1(wrap)
              v-icon(size="18px", color="indigo") mdi-facebook
              a.caption-bold.black--text(
                :href="prop.websiteInfo.linkFacebook",
                target="_blank",
                style="color: #757474; text-decoration: none; margin-left: 5px"
              ) PT. Bank Sumut
            v-layout.mt-1(wrap)
              v-icon(size="18px", color="info") mdi-twitter
              a.caption-bold.black--text(
                :href="prop.websiteInfo.linkTwitter",
                target="_blank",
                style="color: #757474; text-decoration: none; margin-left: 5px"
              ) @banksumut
            v-layout.mt-1(wrap)
              v-icon(size="18px", color="indigo") mdi-instagram
              a.caption-bold.black--text(
                :href="prop.websiteInfo.linkInstagram",
                target="_blank",
                style="color: #757474; text-decoration: none; margin-left: 5px"
              ) @banksumut
            .caption-bold.primary--text(style="text-align: center") {{ prop.version }}
      v-flex.mt-6(lg4, md4, xs12)
        v-card.card-login(max-height="570", elevation="6")
          v-card-text
            .login-logo
            v-layout.mt-4(wrap, justify-center, align="center")
              .title-bold.primary--text Selamat Datang
            v-layout(wrap, justify-center, align="center")
              .title-bold.primary--text di
              .title-bold.secondary--text.ml-2 {{ prop.name }}
            v-flex.error--text(v-if="message", style="text-align: center") {{ message }}
            v-form#form(
              ref="form",
              @submit.prevent="validateLogin",
              autocomplete="off"
            )
              v-container
                v-layout(row, wrap)
                  v-flex
                    div(v-if="prop.simplecaptcha")
                      v-layout.mt-2(wrap)
                        v-flex(lg5, md5, xs12)
                          v-text-field(
                            v-model="captcha",
                            label="Captcha",
                            required,
                            :rules="[(v) => !!v || 'Masukan captcha']",
                            prepend-icon="mdi-shield-half-full"
                          )
                        v-flex(lg6, md6, xs12)
                          v-row
                            v-img(
                              v-bind:src="'data:image/png;base64,' + image",
                              height="50",
                              width="150"
                            )
                            v-icon(color="primary", @click="getSimpleCaptcha") mdi-refresh
                    v-text-field(
                      v-model="login.username",
                      label="Username",
                      required,
                      :rules="[(v) => !!v || 'Masukan username']",
                      prepend-icon="mdi-account-circle"
                    )
                    f-passwordbox(
                      v-model="login.password",
                      label="Password",
                      :required="true",
                      :rules="[(v) => !!v || 'Masukan password']"
                    )
                    .justify-center.mt-2
                      v-btn.white--text(
                        type="submit",
                        form="form",
                        color="btnprimary",
                        style="width: 100%",
                        :disabled="loading",
                        :loading="loading"
                      ) Masuk
                    .justify-end.text-right.mt-2
                      v-btn.caption.font-weight-bold.primary--text(
                        text,
                        @click="routeToMenu('reset-pass')"
                      )
                        v-icon(small, left, color="primary") mdi-help-circle-outline
                        span Lupa Password
                    .mt-2
                      v-row.caption-bold.justify-center.text-center
                        div Dengan Menekan Tombol
                        strong.mx-1 Login
                        div User Menyetujui
                        span.primary--text(
                          style="cursor: pointer",
                          @click="routeToInfoMenu('SECURITY_TERM')"
                        ) Syarat & Ketentuan, (Term & Condition)
                        .mx-1 yang berlaku.
</template> 
<script>
import localforage from "localforage";
import config from "../../../config";
export default {
  name: "FLoginSumut",
  data() {
    return {
      message: "",
      prop: config,
      login: {
        username: "",
        password: "",
      },
      items: [],
      loading: false,
      image: null,
      captcha: null,
      audit: {
        longitude: null,
        latitude: null,
        userAgent: null
      }
    };
  },
  created() {
    if (this.prop.disableRight) {
      window.history.forward(1);
      document.addEventListener("contextmenu", (event) =>
        event.preventDefault()
      );
    }
  },
  mounted() {
    this.setAudit();
    this.getBanner();
    if (this.prop.simplecaptcha) {
      this.getSimpleCaptcha();
    }
  },
  methods: {
    setAudit() {
      if (this.prop.geo) {
        navigator.geolocation.getCurrentPosition(
            position => {
              this.audit.latitude = position.coords.latitude;
              this.audit.longitude = position.coords.longitude;
            }, error => {
              this.audit.latitude = null;
              this.audit.longitude = null;
            },
        );
        this.audit.userAgent = navigator.userAgent;
      } else {
        this.audit.latitude = "Not Secured Connection";
        this.audit.longitude = "Not Secured Connection";
        this.audit.userAgent = "Not Secured Connection";
      }
    },
    doLogin() {
      if (this.$refs.form.validate()) {
        if (this.audit.longitude && this.audit.latitude) {
          this.loading = true;
          this.$session.clear();
          window.$cookies.set("longitudeIbk", this.audit.longitude);
          window.$cookies.set("latitudeIbk", this.audit.latitude);
          window.$cookies.set("userAgentIbk", this.audit.userAgent);
          this.$http
            .post("/api/sec/login", {
              granType: "password",
              username: this.login.username,
              password: this.login.password,
            })
            .then(
              (success) => {
                const data = success.data;
                const accessToken = data.access_token;
                const refresh_token = data.refresh_token;
                var userDetails = data.userDetails;
                var timeout =
                  (userDetails.idleTimeout ? userDetails.idleTimeout : 5) + 1;
  
                window.$cookies.set(
                  "access_token_ibk",
                  accessToken,
                  timeout + "min"
                );
                window.$cookies.set(
                  "refresh_token_ibk",
                  refresh_token,
                  timeout + "min"
                );
                window.$cookies.set("idleTimeoutIbk", timeout, timeout + "min");
                localforage.setItem("userDetailIbk", userDetails);
                
                this.$router.push({ name: "menu" }).catch((err) => {});
              },
              (err) => {
                this.resetCaptcha();
                let cause = err.response.data.cause;
                let message = err.response.data.message;
                this.message = message ? message : cause ? cause : err;
              }
            )
            .finally(() => (this.loading = false));
        }else{
          this.message = "Aktifkan lokasi";
        }
      }
    },
    resetCaptcha() {
      if (this.prop.simplecaptcha) {
        this.getSimpleCaptcha();
        this.captcha = null;
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
    getBanner() {
      this.$http.get("/api/util/banner").then((success) => {
        this.items = success.data;
      });
    },
    getSimpleCaptcha() {
      this.$http
        .get("/api/util/captcha", {
          params: {
            color: "#034EA2",
            height: 48,
            width: 195,
          },
        })
        .then((success) => {
          this.image = success.data;
        });
    },
    validateCaptcha() {
      if (this.$refs.form.validate()) {
        this.$http
          .get("/api/util/captcha-validate", {
            params: {
              captcha: this.captcha,
            },
          })
          .then(
            (success) => {
              this.doLogin();
            },
            (err) => {
              this.message = err.response.data.message;
              this.getSimpleCaptcha();
            }
          );
      }
    },
    validateLogin() {
      if (this.prop.simplecaptcha) {
        this.validateCaptcha();
      } else {
        this.doLogin();
      }
    },
    routeToMenu(code) {
      this.$router.push({ name: code }).catch((err) => {});
    },
    routeToInfoMenu(code) {
      this.$router
        .push({
          name: "info",
          params: { code: code },
        })
        .catch((err) => {});
    },
  },
};
</script>

<style src="../../../assets/style/sumut/login-sumut.css"/>